import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { DangerAlert, Table, WaitingAlert } from '@tmapy/style-guide';
import { QUERY_STATE } from '@tmapy/beetlejuice-utils';

import { useGraphDataResource } from './useChartDataResource';

const msg = defineMessages<any>({
  creatorTitle: {
    id: 'chart.creator.title',
    defaultMessage: 'Počty žádostí o data dle uživatele',
  },
  creatorName: {
    id: 'chart.creator.name',
    defaultMessage: 'Jméno',
  },
  creatorCount: {
    id: 'chart.creator.count',
    defaultMessage: 'Počet',
  },
  queryStateWaiting: {
    id: 'chart.creator.queryStateWaiting',
    defaultMessage: 'Načítám statistická data "creator" - Čekejte prosím...',
  },
  queryStateFail: {
    id: 'chart.creator.queryStateFail',
    defaultMessage: 'Načtení statistických dat "creator" selhalo.',
  },
});

type DataItem = {
  name?: string;
  surname?: string;
  url?: string;
  order_count: number;
};

export const CreatorCountTable = () => {
  const [queryState, setQueryState] = useState<QUERY_STATE>(QUERY_STATE.EMPTY);

  const resource = useGraphDataResource({ graph_type: 'creator_order_count' });
  const data = useMemo<DataItem[] | undefined>(() => {
    setQueryState(resource.queryState);
    if (resource.queryState !== QUERY_STATE.SUCCESS) return;

    // statistika top 10.
    return resource.data?.results.slice(0, 10) as DataItem[];
  }, [resource.data]);

  return (
    <>
      {queryState === QUERY_STATE.WAITING && (
        <WaitingAlert>
          <FormattedMessage {...msg.queryStateWaiting} />
        </WaitingAlert>
      )}
      {queryState === QUERY_STATE.FAIL && (
        <DangerAlert>
          <FormattedMessage {...msg.queryStateFail} />
        </DangerAlert>
      )}

      {data && (
        <div className='sg-u-vs-4'>
          <section>
            <h3 className='sg-u-type-h2 sg-a-ml-2'>
              <FormattedMessage {...msg.creatorTitle} />
            </h3>
            <div className='sg-u-box sg-a-mt-1 dmx-a-mw-fc'>
              <Table>
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage {...msg.creatorName} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.creatorCount} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item: DataItem, idx: number) => (
                    <DataItem key={idx} {...item} />
                  ))}
                </tbody>
              </Table>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

const DataItem = (props: DataItem) => {
  return (
    <tr>
      <td>
        {props.name} {props.surname}
      </td>
      <td className='sg-u-c-body-darkest'>
        <pre>{props.order_count}</pre>
      </td>
    </tr>
  );
};
